export const insuranceValueLayerStyle = {
  width: '100%',
  px: 4,
  py: 2.5,
  bg: 'neutral.50',
  borderBottom: '2px solid',
  // borderBottomColor: 'insurance-value-border',
  // _disabled: {
  borderBottomColor: 'neutral.200',
  // },
  lineHeight: 'normal',
}